// LocationHistoryTable.jsx
const mockHistory = [
  {
    sNo: 1,
    deviceId: "e2612332be88bf77",
    mobile: "OnePlus CPH2585 Android 15",
    mobileTime: "27 Oct 08:20 AM",
    serverTime: "27 Oct 08:20 AM",
    ip: "106.207.221.37",
    latitude: "22.312483",
    longitude: "74.346467",
    distance: "0.00",
    kmCovered: "0.00",
    map: "view",
    address: "11/4, Akola, Madhya Pradesh 457887, India",
    accuracy: "300",
    dataMock: "M",
    type: "False",
    provider: "Google",
    speed: "fused",
  },
  {
    sNo: 2,
    deviceId: "e2612332be88bf77",
    mobile: "OnePlus CPH2585 Android 15",
    mobileTime: "27 Oct 08:21 AM",
    serverTime: "27 Oct 08:21 AM",
    ip: "106.207.221.37",
    latitude: "22.312483",
    longitude: "74.346467",
    distance: "0",
    kmCovered: "0",
    map: "view",
    address: "11/4, Akola, Madhya Pradesh 457887, India",
    accuracy: "300",
    dataMock: "M",
    type: "False",
    provider: "Google",
    speed: "fused",
  },
];

export default function LocationHistoryTable() {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 p-6">
        <h2 className="text-2xl font-bold text-white">Location History</h2>
        <p className="text-blue-100 mt-2">Abdullah Khan - 27 Oct 2025</p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <thead className="bg-blue-50 sticky top-0">
            <tr>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">S.No</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Device ID</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Mobile</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Mobile Time</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Server Time</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">I.P.</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Latitude</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Longitude</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Distance (K.M.)</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Map</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Address</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Accuracy (68% In Meter)</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Data Mock</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Type</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Provider</th>
              <th className="border border-gray-300 px-3 py-2 text-left font-semibold text-gray-700">Speed</th>
            </tr>
          </thead>
          <tbody>
            {mockHistory.map((row) => (
              <tr key={row.sNo} className="hover:bg-gray-50 border-b border-gray-200">
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.sNo}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700 text-xs">{row.deviceId}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700 text-xs">{row.mobile}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.mobileTime}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.serverTime}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.ip}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.latitude}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.longitude}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.distance}</td>
                <td className="border border-gray-300 px-3 py-2 text-blue-600 hover:underline cursor-pointer">{row.map}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700 text-xs">{row.address}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.accuracy}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.dataMock}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.type}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.provider}</td>
                <td className="border border-gray-300 px-3 py-2 text-gray-700">{row.speed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="bg-gray-50 px-6 py-4 flex gap-4 justify-center">
        <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 font-medium">Print</button>
        <button className="bg-red-600 text-white px-6 py-2 rounded-md hover:bg-red-700 font-medium">Close</button>
        <button className="bg-green-600 text-white px-6 py-2 rounded-md hover:bg-green-700 font-medium">Export to Excel</button>
      </div>
    </div>
  );
}
